<script lang="ts">
	interface Props {
		class?: string;
		wrapperClass?: string;
		children?: import('svelte').Snippet;
	}

	let { class: clazz = '', wrapperClass = '', children }: Props = $props();
</script>

<div class={`page-wrapper ${wrapperClass}`}>
	<div class={`mx-auto max-w-screen-xl ${clazz}`}>
		{@render children?.()}
	</div>
</div>
